/* HN MTO Customization bridge — fix for HulkApps Product Options upcharge leak.
 *
 * Listens for Symmetry's cart events. When a Made-to-Order item is in cart
 * with properties whose values contain bracketed upcharge amounts (e.g.
 * "Yorkshire Brandy | Aniline Leather [ $3672.5 ]"), this script keeps a
 * matching qty of the hidden "Made-to-Order Customization" product (variant
 * priced $1.00) in the cart, linked via _parent_key.
 *
 * Self-healing reconciliation: on every cart change, walks the cart and:
 *   - adds a customization line for any parent with [ $X ] properties and
 *     no matching customization line
 *   - updates quantity when parent qty changes
 *   - removes orphan customization lines whose parent is gone
 *   - REMOVES HulkApps-injected "Customization Cost for [Product]" lines
 *     (HulkApps' own broken add path — their line plus ours double-charges)
 *
 * Also: hides any "Shop Pay" / dynamic-checkout buttons on MTO product pages.
 * Also: 8-second safety-net poll on visible pages — catches HulkApps adds
 * that fire outside our event listeners.
 * Also: on /cart page, force a reload after reconcile changes the cart, so
 * the server-rendered totals reflect the post-reconcile state.
 * Also: overwrites the header cart-link badge to exclude hidden customization
 * units (so customers see "1" not "4514").
 *
 * Throwaway. Delete when MTO migrates to native variants.
 */
(function () {
  'use strict';

// Block HulkApps from hijacking the Checkout button — its /do/ route double-charges.
// Forces customers through the standard /cn/ checkout where the bridge JS handles upcharges.
(function () {
  try {
    Object.defineProperty(window, 'hulkappsCheckout', {
      configurable: true,
              get: function () {
          return function () {
            window.location.href = '/checkout';
            return true;
          };
        },
      set: function () { /* block HulkApps from reassigning */ }
    });
  } catch (e) { console.warn('[HN MTO] hulkappsCheckout override failed', e); }
})();

  var UPGRADE_VARIANT_ID = 66868386562093;
  var UPGRADE_PRODUCT_ID = 15134794940461;

  var processing = false;
  var pending = false;
  var reloadScheduled = false;

  function isHulkAppsChargeLine(item) {
    // HulkApps' Shop Pay integration adds a synthetic line item titled
    // "Customization Cost for [Product] - [Variant]".
    var title = (item.product_title || item.title || '').toLowerCase();
    if (title.indexOf('customization cost') === 0) return true;
    if (title.indexOf('customization cost for') !== -1) return true;
    if (item.product_id === UPGRADE_PRODUCT_ID) return false;
    if (item.properties && item.properties['Custom Product']) return true;
    return false;
  }

  function isMtoProductPage() {
    var b = document.body;
    if (!b) return false;
    return b.classList.contains('template-suffix-made-to-order')
        || b.classList.contains('template-suffix-made-to-order-beds');
  }

  function injectMtoCss() {
    if (document.getElementById('hn-mto-css')) return;
    var s = document.createElement('style');
    s.id = 'hn-mto-css';
    s.textContent = [
      '.shopify-payment-button,',
      '.shopify-buy-it-now-button,',
      '.product-form__buy-buttons .shopify-payment-button,',
      '.dynamic-checkout-buttons,',
      'shopify-buy-it-now-button',
      '{ display: none !important; visibility: hidden !important; }'
    ].join(' ');
    (document.head || document.documentElement).appendChild(s);
  }

  if (isMtoProductPage()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectMtoCss);
    } else {
      injectMtoCss();
    }
  }

  function parseUpcharges(properties) {
    var result = { total: 0, breakdown: [] };
    if (!properties || typeof properties !== 'object') return result;
    Object.keys(properties).forEach(function (key) {
      if (key.charAt(0) === '_') return;
      var value = properties[key];
      if (typeof value !== 'string') return;
      var match = value.match(/\[\s*\$([\d.]+)\s*\]/);
      if (!match) return;
      var dollars = parseFloat(match[1]);
      if (!isFinite(dollars) || dollars <= 0) return;
      result.total += dollars;
      result.breakdown.push(key + ': $' + dollars.toFixed(2));
    });
    return result;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed: ' + r.status);
        return r.json();
      });
  }

  function addUpgradeLine(parent, upcharge, qty) {
    var form = new FormData();
    form.append('id', String(UPGRADE_VARIANT_ID));
    form.append('quantity', String(qty));
    form.append('properties[Customization for]', parent.product_title || parent.title || '');
    form.append('properties[Details]', upcharge.breakdown.join(' | '));
    form.append('properties[_parent_key]', parent.key || '');
    form.append('properties[_parent_variant]', String(parent.variant_id || ''));
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: form
    });
  }

  function changeLineQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function refreshCartDrawer() {
    try {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    } catch (e) { /* ignore */ }
  }

  function updateBadgeCount(cart) {
    if (!cart) return;
    var hidden = 0;
    (cart.items || []).forEach(function (i) {
      if (Number(i.variant_id) === Number(UPGRADE_VARIANT_ID)) hidden += i.quantity;
      if (isHulkAppsChargeLine(i)) hidden += i.quantity;
    });
    var visible = Math.max(0, (cart.item_count || 0) - hidden);
    var els = document.querySelectorAll('.cart-link__count');
    for (var k = 0; k < els.length; k++) {
      els[k].textContent = visible > 0 ? String(visible) : '';
    }
  }

  function isCartPage() {
    return /^\/cart(\b|\?|\/|$)/.test(window.location.pathname + window.location.search);
  }

  function maybeReloadCartPage(changed) {
    if (!changed) return;
    if (!isCartPage()) return;
    if (reloadScheduled) return;
    reloadScheduled = true;
    setTimeout(function () { window.location.reload(); }, 150);
  }

  function reconcile() {
    if (processing) { pending = true; return Promise.resolve(); }
    processing = true;
    return getCart().then(function (cart) {
      updateBadgeCount(cart);
      var upgradesByParent = {};
      var orphanUpgrades = [];
      var hulkAppsLines = [];
      (cart.items || []).forEach(function (item) {
        if (isHulkAppsChargeLine(item)) {
          hulkAppsLines.push(item);
          return;
        }
        if (Number(item.variant_id) !== Number(UPGRADE_VARIANT_ID)) return;
        var pk = item.properties && item.properties._parent_key;
        if (pk) upgradesByParent[pk] = item;
        else orphanUpgrades.push(item);
      });

      var ops = [];
      var changed = false;

      // Nuke any HulkApps charge lines first.
      hulkAppsLines.forEach(function (h) {
        changed = true;
        ops.push(changeLineQty(h.key, 0));
      });

      (cart.items || []).forEach(function (parent) {
        if (isHulkAppsChargeLine(parent)) return;
        if (Number(parent.variant_id) === Number(UPGRADE_VARIANT_ID)) return;
        var upcharge = parseUpcharges(parent.properties);
        if (upcharge.total <= 0) return;
        var expectedQty = Math.ceil(upcharge.total * parent.quantity);
        var existing = upgradesByParent[parent.key];
        if (!existing) {
          changed = true;
          ops.push(addUpgradeLine(parent, upcharge, expectedQty));
        } else if (existing.quantity !== expectedQty) {
          changed = true;
          ops.push(changeLineQty(existing.key, expectedQty));
        }
        delete upgradesByParent[parent.key];
      });

      Object.keys(upgradesByParent).forEach(function (k) {
        changed = true;
        ops.push(changeLineQty(upgradesByParent[k].key, 0));
      });
      orphanUpgrades.forEach(function (o) {
        changed = true;
        ops.push(changeLineQty(o.key, 0));
      });

      return Promise.all(ops).then(function () { return changed; });
    }).then(function (changed) {
      processing = false;
      if (changed) {
        refreshCartDrawer();
        getCart().then(updateBadgeCount).catch(function () {});
        maybeReloadCartPage(true);
      }
      if (pending) { pending = false; return reconcile(); }
    }).catch(function (err) {
      processing = false;
      console.error('[HN MTO upgrade] reconcile error', err);
    });
  }

  function scheduleReconcile(delay) {
    setTimeout(reconcile, delay || 100);
  }

  document.addEventListener('on:cart:add', function () { scheduleReconcile(50); });
  document.addEventListener('on:cart:after-merge', function () { scheduleReconcile(30); });
  document.addEventListener('on:cart-drawer:before-open', function () { scheduleReconcile(0); });
  document.addEventListener('on:cart-drawer:after-open', function () { scheduleReconcile(200); });

  function bootReconcile() {
    getCart().then(updateBadgeCount).catch(function () {});
    scheduleReconcile(200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReconcile);
  } else {
    bootReconcile();
  }

  // Safety net: re-check every 8s while tab is visible. Catches HulkApps adds
  // that fire outside any event we listen to.
  setInterval(function () {
    if (document.hidden) return;
    scheduleReconcile(0);
  }, 8000);
})();
